var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAwsAmplify = function SvgAwsAmplify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 191",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "22.172%",
    x2: "0%",
    y2: "77.828%",
    id: "aws_amplify_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F90",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC300",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.71 158.476h72.106l18.47 32.508H0l51.364-89.006L72.89 64.706l18.48 32.022-35.66 61.748ZM82.6 47.85l17.744-30.746 100.42 173.88h-35.562L82.601 47.85ZM110.221 0h35.516L256 190.984h-35.56L110.22 0Z",
    fill: "url(#aws_amplify_svg__a)"
  })));
};
export default SvgAwsAmplify;